export const PLACEHOLDER_PATTERN = /%([a-zA-Z0-9 _.-]+)%/g
export const CUSTOM_NAME_PLACEHOLDER_PATTERN = /%(name|lname|uname)%/g
